import FilterChip from "@/app/components/filters/FilterChip";
import FilterWrapper, {
  useFilterWrapperStyles,
} from "@/app/components/filters/FilterWrapper";
import { Chip, Text } from "@mantine/core";
import { QuestionDifficulty, QuestionFormat } from "enums/contentTypes";
import { Dispatch, SetStateAction } from "react";

export default function QuestionFilters({
  selectedDifficulty,
  setSelectedDifficulty,
  selectedFormat,
  setSelectedFormat,
}: {
  selectedDifficulty: QuestionDifficulty[];
  setSelectedDifficulty: Dispatch<SetStateAction<QuestionDifficulty[]>>;
  selectedFormat: QuestionFormat[];
  setSelectedFormat: Dispatch<SetStateAction<QuestionFormat[]>>;
}) {
  const activeFilterCount = selectedFormat.length + selectedDifficulty.length;
  const { classes: filterWrapperClasses } = useFilterWrapperStyles();

  return (
    <FilterWrapper activeFilterCount={activeFilterCount}>
      <Text className={filterWrapperClasses.filterTitle}>Question Format</Text>
      <Chip.Group
        multiple={true}
        value={selectedFormat}
        onChange={(value) => setSelectedFormat(value as QuestionFormat[])}
      >
        <FilterChip label={"MC"} checked={selectedFormat.includes("MC")} />
        <FilterChip label={"LA"} checked={selectedFormat.includes("LA")} />
      </Chip.Group>
      <Text className={filterWrapperClasses.filterTitle}>Difficulty</Text>
      <Chip.Group
        multiple={true}
        value={selectedDifficulty}
        onChange={(value) =>
          setSelectedDifficulty(value as QuestionDifficulty[])
        }
      >
        <FilterChip
          label={"Easy"}
          checked={selectedDifficulty.includes("Easy")}
        />
        <FilterChip
          label={"Medium"}
          checked={selectedDifficulty.includes("Medium")}
        />
        <FilterChip
          label={"Hard"}
          checked={selectedDifficulty.includes("Hard")}
        />
      </Chip.Group>
    </FilterWrapper>
  );
}
